import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';

import { AssetStoryblok } from '../../types/generated-storyblok';
import { Image } from '../Image';

type Props = {
  artist?: string;
  image?: AssetStoryblok;
  isSubscribed?: boolean;
  isLoading?: boolean;
  onSubscribe: () => Promise<void>;
  title?: string;
};

export const ProductPlaceholder = ({
  artist,
  image,
  isLoading = false,
  isSubscribed = false,
  onSubscribe,
  title,
}: Props) => {
  const { t } = useTranslation(['artists', 'authentication']);

  return (
    <div className="theme-dark relative aspect-[3/4] w-full overflow-hidden rounded-sm bg-neutral-2">
      {image ? (
        <>
          <Image
            alt={image?.alt || ''}
            eagerLoading
            focus={image.focus}
            size={{
              sm: { ratio: '3/4', span: 12 },
              md: { ratio: '3/4', span: 6 },
              lg: { ratio: '3/4', span: 4 },
            }}
            src={image.filename}
          />

          <span className="absolute inset-0 bg-neutral-6/40 backdrop-blur-md" />
        </>
      ) : null}

      <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
        <p className="font-bold text-white">
          {title || t('worksPlaceholder.title', { artist })}
        </p>
        <p className="mb-6 text-white">{t('worksPlaceholder.description')}</p>

        <Button
          disabled={isSubscribed}
          hideLabel={isSubscribed}
          icon={
            isSubscribed ? 'ic_notification_active' : 'ic_notification_outline'
          }
          label={t('worksPlaceholder.button')}
          loading={isLoading}
          onClick={onSubscribe}
          size="md"
          variant={isSubscribed ? 'positive' : 'primary'}
        />
      </div>
    </div>
  );
};
